import React from "react";
import {
  Breadcrumbs,
  Card,
  Chip,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Divider from "@mui/material/Divider";
import Lightbox from "react-image-lightbox";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { Link, useParams } from "react-router-dom";
import { useGetPartByIdMutation } from "../../redux/reducer/features/Part/partSlice";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { Part } from "../../models/features/Part/Parts";
import PageLoader from "../app/PageLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export interface DetailProps {}
export const PartDetails: React.FunctionComponent<DetailProps> = () => {
  let { id } = useParams();
  const [partDetail, setPartDetail] = React.useState<Part>();
  const [detailMutation, detailMutationResult] = useGetPartByIdMutation();
  const [URL, setURL] = React.useState("");
  const [isOpen, setOpen] = React.useState(false);

  React.useEffect(() => {
    console.log("ID Recieved in params", id);
    detailMutation({ data: id });
  }, []);
  const handleLightBoxOpen = () => {
    setOpen(true);
  };
  const handleLightBoxClose = () => {
    setOpen(false);
  };
  React.useEffect(() => {
    if (detailMutationResult.data) {
      console.log("success", detailMutationResult.data);
      setPartDetail(detailMutationResult.data.entity);
    }
  }, [detailMutationResult]);

  console.log(id);
  return (
    <Container maxWidth={false}>
      <PageLoader isLoading={detailMutationResult.isLoading}></PageLoader>
      <Card style={{ padding: "10px", margin: "10px" }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" to="/">
            Dashboard
          </Link>
          <Link color="inherit" to="/Parts">
            Parts
          </Link>
          <Typography color="text.primary">Part Detail</Typography>
        </Breadcrumbs>
      </Card>
      <Card style={{ padding: "10px", margin: "10px" }}>
        <Grid container spacing={4} justifyContent="flex-start">
          <Grid item xs={12} md={6} pr={2}>
            {partDetail && partDetail?.images ? (
              <Carousel width={"100%"}>
                {partDetail?.images.map((img: any) => {
                  return (
                    <div
                      onClick={() => {
                        handleLightBoxOpen();
                        setURL(img?.absoluteUrl ?? "");
                      }}
                    >
                      <img
                        style={{ width: "100%" }}
                        src={img.absoluteUrl}
                      ></img>
                    </div>
                  );
                })}
              </Carousel>
            ) : (
              ""
            )}
          </Grid>
          <Grid
            item
            mt={4}
            xs={12}
            md={6}
            sx={{
              border: "1px solid #dee2e6 !important",
              minHeight: "70vh",
            }}
          >
            <Typography
              variant="h4"
              sx={{ fontWeight: 700, textTransform: "uppercase" }}
            >
              {partDetail?.title}
            </Typography>
            <Divider />
            <Typography
              mt={3}
              mb={3}
              sx={{ fontWeight: 700, fontSize: "1.5rem" }}
            >
              Part Overview
            </Typography>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontWeight: 700 }}>Description</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        partDetail && partDetail.description
                          ? partDetail?.description
                          : "",
                    }}
                  ></span>
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography sx={{ fontWeight: 700 }}>
                  Weight & Dimension
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Height</TableCell>
                      <TableCell align="right">Weight</TableCell>
                      <TableCell align="right">Length</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {partDetail?.dimension?.height}in
                      </TableCell>
                      <TableCell align="right">
                        {partDetail?.dimension?.weight}lbs
                      </TableCell>
                      <TableCell align="right">
                        {partDetail?.dimension?.depth}in
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
              >
                <Typography sx={{ fontWeight: 700 }}>Specifications</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Table aria-label="customized table">
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell component="th">
                        Part Number
                      </StyledTableCell>
                      <StyledTableCell>
                        {partDetail?.partNumber}
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell>Tags</StyledTableCell>
                      <StyledTableCell>
                        {partDetail && partDetail.tags
                          ? partDetail.tags.map((item: any) => (
                              <Chip label={item} />
                            ))
                          : ""}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>{" "}
      </Card>
      {isOpen && (
        <Lightbox mainSrc={URL} onCloseRequest={handleLightBoxClose} />
      )}
    </Container>
  );
};
